const DATE_REG_EXP = /^(\d{1,2})([/-])(\d{1,2})([/-])(\d{4})\b/;
export function coerceToBoolean(val) {
  if (val === '') {
    return true;
  }
  return Boolean(val);
}
export function coerceToDate(value) {
  if (value instanceof Date) return value;
  const parts = DATE_REG_EXP.exec(value);
  if (parts && parts[2] === parts[4]) {
    return new Date(+parts[5], +parts[1] - 1, +parts[3]);
  }
  return new Date();
}
export function coerceToNumber(value) {
  if (typeof value === 'number') {
    return value;
  }
  const val = parseFloat(value);
  return isNaN(val) ? 0 : val;
}
export const booleanConverter = {
  fromAttribute(val) {
    return coerceToBoolean(val);
  },
  toAttribute(val) {
    val = coerceToBoolean(val);
    if (!val) {
      return null;
    }
    return '';
  }
};
export const dateToStringConverter = {
  fromAttribute(val) {
    return val;
  },
  toAttribute(val) {
    if (val instanceof Date) {
      return val.toISOString();
    }
    return val;
  }
};
//# sourceMappingURL=type-utils.js.map